// eslint-disable-next-line max-classes-per-file
import React from 'react';
import PropTypes from 'prop-types';
import { FormSpy } from 'react-final-form';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import GenericToggleButtonGroupField from '../../../commons/form-fields/GenericToggleButtonGroupField';
import {
    relevantBackgroundInfoQuestions,
    yesNoOptions,
} from '../../OnboardingConstants';
import GenericTextAreaInputField from '../../../commons/form-fields/GenericTextAreaInputField';

function renderQuestionComponent(question, answerObj) {
    const isAnswerYes = answerObj?.[question.name] === 'Yes';
    if (!question.children) {
        return (
            <div>
                <GenericToggleButtonGroupField
                    name={`info.background.${question.name}`}
                    inlineLabel={question.label}
                    options={yesNoOptions}
                    required
                />
                {isAnswerYes && (
                    <GenericTextAreaInputField
                        name={`info.background.${question.name}Desc`}
                        label={
                            question.descLabel ||
                            'Please provide a brief explanation of your answer.'
                        }
                        required
                        clearOnUnmount
                    />
                )}
            </div>
        );
    }

    return (
        <div>
            <p className={'text-gray-700 mb-2 md:mb-1 pl-2'}>
                {question.label}
            </p>
            <ol className={'pl-6'}>
                {question.children.map((que, index) => (
                    <li type="1" key={index}>
                        <QuestionRenderer
                            question={que}
                            key={index}
                            answerObj={answerObj}
                        />
                    </li>
                ))}
            </ol>
        </div>
    );
}

class QuestionRenderer extends React.Component {
    render() {
        const { question, answerObj } = this.props;
        return <div>{renderQuestionComponent(question, answerObj)}</div>;
    }
}

QuestionRenderer.propTypes = {
    question: PropTypes.object,
    answerObj: PropTypes.object,
};

class BackgroundInfoInner extends React.Component {
    render() {
        const answerObj = this.props.values.info?.background;

        return (
            <div className="max-w-4xl mx-auto bg-white px-6 py-1 md:mt-3 md:mb-6 rounded shadow-md text-sm">
                <HeaderAndError
                    label="Relevant Background Information"
                    style="block text-xl text-teal-700 font-bold pl-1 pt-4"
                />
                <label className="block text-sm text-teal-700 italic pl-1 pb-4">
                    If your answer to any of the following questions is
                    &#39;Yes&#39;, please describe in the comments section
                    below.
                </label>

                <ol className={'pl-4'}>
                    {relevantBackgroundInfoQuestions.map((question, index) => (
                        <li type="a" key={index}>
                            <QuestionRenderer
                                question={question}
                                key={index}
                                answerObj={answerObj}
                            />
                        </li>
                    ))}
                </ol>
            </div>
        );
    }
}

BackgroundInfoInner.propTypes = {
    values: PropTypes.any,
};

const BackgroundInfoFormSection = (props) => (
    <FormSpy {...props} component={BackgroundInfoInner} />
);

export { BackgroundInfoFormSection };
